import gql from 'graphql-tag';

export default gql`
  fragment CommonCall on Call {
    _id
    caller {
      _id
      name
      image {
        _id
        thumbnail
      }
    }
    receivers {
      _id
      name
      image {
        _id
        thumbnail
      }
    }
    createdAt
  }
`;
